export const handleFilterSelect = (inputValue, option) => {
  return option.children.toLowerCase().includes(inputValue.toLowerCase().trim())
}
